import { Button, Paper, Slide, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Navigation } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { EventEmitter } from "utils/EventEmitter";

const useStyles = (props) =>
  makeStyles((theme) => ({
    text: {
      // color: "#fff",
      // marginRight: 16,
    },
    refreshImt: {
      position: "fixed",
      zIndex: "9999",
      bottom: "50px",
      left: "50px",
      padding: theme.spacing(2),
      // backgroundColor: theme.palette.success.light,
      // visibility: props.show ? "visible" : "hidden",
    },
    button: {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
  }));

export default function Refresh() {
  const [show, setShow] = useState(false);
  const [isTimerShown, setIsTimerShown] = useState(false);
  const theme = useTheme();
  const [second, setSecond] = useState(60);
  const classes = useStyles({ show })();

  useEffect(() => {
    EventEmitter.subscribe("showUpdatePopup", (data) => {
      if (!data) return;
      const { timer } = data;
      console.log("Update popup", data);
      if (!timer) {
        setSecond(10);
      }
      setIsTimerShown(timer);
      setShow(true);
    });
  }, []);

  useEffect(() => {
    if (show) {
      setInterval(() => {
        setSecond((s) => (s > 0 ? s - 1 : 0));
      }, 1000);
    }
  }, [show]);

  useEffect(() => {
    if (second == 0) {
      if (isTimerShown) {
        setShow(false);
        reload();
      } else {
        setShow(false);
      }
    }
  }, [second, isTimerShown]);

  const reload = () => {
    window.location.reload();
  };

  return (
    <Slide
      direction="up"
      in={show}
      mountOnEnter
      unmountOnExit
      timeout={{
        appear: 500,
        enter: 300,
        exit: 500,
      }}
    >
      <Paper elevation={3} className={classes.refreshImt}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <Navigation htmlColor={theme.palette.primary.main} fontSize="large" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              paddingLeft: 16,
              paddingRight: 16,
            }}
          >
            {isTimerShown ? (
              <>
                <Typography
                  variant="body1"
                  component="span"
                  className={classes.text}
                >
                  There is an update. Please refresh!{" "}
                </Typography>
                <Typography
                  variant="caption"
                  component="span"
                  className={classes.text}
                  color="textSecondary"
                >
                  Auto refreshing in {second} second(s).
                </Typography>
              </>
            ) : (
              <Typography
                variant="body1"
                component="span"
                className={classes.text}
              >
                Hi, We have updated ImTime for you to have an even better
                experience.
              </Typography>
            )}
          </div>
          {isTimerShown && (
            <div>
              <Button
                variant="outlined"
                color="primary"
                onClick={reload}
                className={classes.button}
              >
                Refresh Now
              </Button>
            </div>
          )}
        </div>
      </Paper>
    </Slide>
  );
}
